var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._m(0),
      !_vm.passwordFlag
        ? _c(
            "div",
            [
              _c(
                "div",
                {
                  staticClass: "col-sm-12 col-md-12 col-xs-12",
                  attrs: { id: "profile-body" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-sm-6", attrs: { id: "profile-icon" } },
                    [
                      _c(
                        "div",
                        { staticClass: "col-sm-12 col-xs-5 xs-pd-lt-0" },
                        [
                          _vm.loggedInInitialsFlag
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "profile-pic-edit profile-pic-title-edit",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getInitials(
                                          _vm.loggedInUser.first_name,
                                          _vm.loggedInUser.last_name
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          !_vm.loggedInInitialsFlag
                            ? _c("img", {
                                staticClass: "profile-pic-edit",
                                attrs: {
                                  src: _vm.imageData,
                                  alt: "profile-icon",
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                      _c("div", { staticClass: "col-sm-12 col-xs-7 p-0" }, [
                        _c("div", { staticClass: "col-xs-12 p-0" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn chng-photo emergo-white-button",
                            },
                            [
                              _vm._v(" Change Photo "),
                              _c("input", {
                                ref: "fileImage",
                                staticClass: "file-upload-hide",
                                attrs: { type: "file", accept: "image/*" },
                                on: { change: _vm.previewImage },
                              }),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "col-xs-12 p-0" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "font-properties cursor-pointer fs-16 ln-ht19 remove_photo",
                              attrs: { disabled: _vm.loggedInInitialsFlag },
                              on: { click: _vm.removePhotoUseInitials },
                            },
                            [_vm._v(" Remove Photo ")]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  Object.keys(_vm.loggedInUser).length
                    ? _c(
                        "div",
                        {
                          staticClass: "col-sm-6 col-md-6 col-xs-12",
                          attrs: { id: "profile-details" },
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _vm._m(1),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-sm-12 col-xs-12 field_css xs-mr-bt-0",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.loggedInUser.first_name,
                                      expression: "loggedInUser.first_name",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", maxlength: "35" },
                                  domProps: {
                                    value: _vm.loggedInUser.first_name,
                                  },
                                  on: {
                                    keyup: _vm.checkUpdatedFields,
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.loggedInUser,
                                        "first_name",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                            _vm._m(2),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-sm-12 col-xs-12 field_css xs-mr-bt-0",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.loggedInUser.last_name,
                                      expression: "loggedInUser.last_name",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", maxlength: "35" },
                                  domProps: {
                                    value: _vm.loggedInUser.last_name,
                                  },
                                  on: {
                                    keyup: _vm.checkUpdatedFields,
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.loggedInUser,
                                        "last_name",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "col-sm-12 col-xs-12 form-group" },
                              [_vm._v("Title")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-sm-12 col-xs-12 field_css xs-mr-bt-0",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.loggedInUser.title,
                                      expression: "loggedInUser.title",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", maxlength: "50" },
                                  domProps: { value: _vm.loggedInUser.title },
                                  on: {
                                    keyup: _vm.checkUpdatedFields,
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.loggedInUser,
                                        "title",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "col-sm-12 col-xs-12 form-group" },
                              [_vm._v("Legal Company Name")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-sm-12 col-xs-12 field_css xs-mr-bt-0",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.loggedInUser.company,
                                      expression: "loggedInUser.company",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", disabled: "disabled" },
                                  domProps: { value: _vm.loggedInUser.company },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.loggedInUser,
                                        "company",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "col-sm-12 col-xs-12 form-group" },
                              [_vm._v("Email")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-sm-12 col-xs-12 field_css xs-mr-bt-0",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.loggedInUser.email,
                                      expression: "loggedInUser.email",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", disabled: "disabled" },
                                  domProps: { value: _vm.loggedInUser.email },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.loggedInUser,
                                        "email",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "col-sm-12 col-xs-12 form-group" },
                              [_vm._v("Account ID")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-sm-12 col-xs-12 field_css xs-mr-bt-0",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.loggedInUser.account_id,
                                      expression: "loggedInUser.account_id",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", disabled: "disabled" },
                                  domProps: {
                                    value: _vm.loggedInUser.account_id,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.loggedInUser,
                                        "account_id",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm-12 col-xs-12 sec-pad" }, [
                      _vm._v("Security"),
                    ]),
                    _vm._m(3),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12 col-md-12" },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-sm-4 col-md-4 col-xs-8" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-block emergo-blue-button",
                                  attrs: { type: "button" },
                                  on: { click: _vm.redirectChangePassword },
                                },
                                [_vm._v(" Change Password ")]
                              ),
                            ]
                          ),
                          _vm.loggedInUser.role_id === 1 &&
                          _vm.loggedInUser.account_type_id === 3 &&
                          _vm.loggedInUser.id === _vm.userData.id
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-sm-4 col-md-4 col-xs-8 pl-0 d-flex",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-block emergo-white-button",
                                      attrs: { type: "button" },
                                      on: { click: _vm.deactivateModal },
                                    },
                                    [_vm._v(" Deactivate Account ")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "ml-6 pt-5" },
                                    [
                                      _c(
                                        "el-popover",
                                        {
                                          staticClass:
                                            "cursor-pointer custom-popover",
                                          attrs: {
                                            placement: "bottom-end",
                                            trigger: "click",
                                            width: "360",
                                          },
                                          on: {
                                            show: function ($event) {
                                              _vm.infoActiveAcct = true
                                            },
                                            hide: function ($event) {
                                              _vm.infoActiveAcct = false
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "limit_popover_txt",
                                            },
                                            [
                                              _vm._v(
                                                " By deactivating your account, you and all team members on this account will lose access to all data available within RAMS. You can be added as a team member on another RAMS account. "
                                              ),
                                            ]
                                          ),
                                          !_vm.infoActiveAcct
                                            ? _c("img", {
                                                staticClass: "info-img",
                                                attrs: {
                                                  slot: "reference",
                                                  src: "/static/images/icons/info_icon.svg",
                                                  alt: "info-icon",
                                                },
                                                slot: "reference",
                                              })
                                            : _vm._e(),
                                          _vm.infoActiveAcct
                                            ? _c("img", {
                                                staticClass: "info-img",
                                                attrs: {
                                                  slot: "reference",
                                                  src: "/static/images/icons/info_icon_active.svg",
                                                  alt: "infoactive-icon",
                                                },
                                                slot: "reference",
                                              })
                                            : _vm._e(),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.loggedInUser.role_id === 1 &&
                          _vm.loggedInUser.account_type_id === 3
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-sm-12 col-md-12 col-xs-12 support-access",
                                },
                                [
                                  _c("div", [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "checkbox inline-checkbox",
                                      },
                                      [
                                        _c("label", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.loggedInUser
                                                    .allow_support_access,
                                                expression:
                                                  "loggedInUser.allow_support_access",
                                              },
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.loggedInUser
                                                  .allow_support_access
                                              )
                                                ? _vm._i(
                                                    _vm.loggedInUser
                                                      .allow_support_access,
                                                    null
                                                  ) > -1
                                                : _vm.loggedInUser
                                                    .allow_support_access,
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$a =
                                                      _vm.loggedInUser
                                                        .allow_support_access,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          _vm.loggedInUser,
                                                          "allow_support_access",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          _vm.loggedInUser,
                                                          "allow_support_access",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      _vm.loggedInUser,
                                                      "allow_support_access",
                                                      $$c
                                                    )
                                                  }
                                                },
                                                _vm.checkUpdatedFields,
                                              ],
                                            },
                                          }),
                                          _c("span", { staticClass: "cr" }),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      [
                                        _vm._v(
                                          "Allow temporary authorized technical support access "
                                        ),
                                        _c(
                                          "el-popover",
                                          {
                                            staticClass:
                                              "cursor-pointer custom-popover",
                                            attrs: {
                                              placement: "bottom-end",
                                              trigger: "click",
                                              width: "360",
                                            },
                                            on: {
                                              show: function ($event) {
                                                _vm.infoActive = true
                                              },
                                              hide: function ($event) {
                                                _vm.infoActive = false
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "limit_popover_txt",
                                              },
                                              [
                                                _vm._v(
                                                  " By checking this box, you are enabling authorized Technical Support personnel to gain access to your RAMS account and data. Temporary access expires after 72 hours "
                                                ),
                                              ]
                                            ),
                                            !_vm.infoActive
                                              ? _c("img", {
                                                  staticClass: "info-img",
                                                  attrs: {
                                                    slot: "reference",
                                                    src: "/static/images/icons/info_icon.svg",
                                                    alt: "info-icon",
                                                  },
                                                  slot: "reference",
                                                })
                                              : _vm._e(),
                                            _vm.infoActive
                                              ? _c("img", {
                                                  staticClass: "info-img",
                                                  attrs: {
                                                    slot: "reference",
                                                    src: "/static/images/icons/info_icon_active.svg",
                                                    alt: "infoactive-icon",
                                                  },
                                                  slot: "reference",
                                                })
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "modal deactive-modal",
                            attrs: {
                              role: "dialog",
                              "data-backdrop": "static",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "modal-dialog",
                                attrs: { role: "document" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "modal-content deactivate-acct",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "modal-header upgradeModal-bgcolor",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "close",
                                            attrs: {
                                              type: "button",
                                              "data-target": "#UpgradeModal",
                                            },
                                            on: { click: _vm.closePopup },
                                          },
                                          [_vm._v(" × ")]
                                        ),
                                        _vm._m(4),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "modal-body deactivate-body",
                                      },
                                      [
                                        _vm._v(
                                          " All associated access will be removed for all team members on this account. You will be immediately logged out. Do you want to proceed with account deactivation? "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "modal-footer cancelModal-bgcolor",
                                      },
                                      [
                                        _c("div", { staticClass: "row" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-lg-offset-6 col-md-offset-6",
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn proceed-btn emergo-white-button",
                                                  on: {
                                                    click:
                                                      _vm.deactivateAccount,
                                                  },
                                                },
                                                [_vm._v(" Yes, proceed ")]
                                              ),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn please-cancel",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.closePopup()
                                                    },
                                                  },
                                                },
                                                [_vm._v("Dismiss")]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
              _c("div", { staticClass: "footer col-xs-12 col-sm-12" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-md-2 col-md-offset-7 col-sm-offset-5 col-sm-3 col-xs-5 xs-pd-lt-0",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-white-button",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("closepopup", "closeBasePopup")
                          },
                        },
                      },
                      [_vm._v(" Cancel ")]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-md-3 col-sm-4 col-xs-7 xs-pd-lt-0 xs-pd-rt-0",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-green-button",
                        attrs: {
                          type: "button",
                          disabled:
                            _vm.disableButtonForProfile || _vm.loaderStatus,
                        },
                        on: { click: _vm.updateProfile },
                      },
                      [_vm._v(" Save Changes ")]
                    ),
                  ]
                ),
              ]),
              _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
            ],
            1
          )
        : _c("div", { attrs: { id: "change-password" } }, [
            _c(
              "div",
              {
                staticClass:
                  "col-lg-6 col-sm-12 col-md-12 col-xs-12 changepassword_wrapper",
                attrs: { id: "body" },
              },
              [
                _c(
                  "div",
                  { staticClass: "col-lg-12 col-md-6 col-sm-7 pass-info" },
                  [
                    _c("p", { staticClass: "pass-desc pl-0" }, [
                      _vm._v("Provide password details below:"),
                    ]),
                    _c(
                      "el-popover",
                      {
                        staticClass: "info-icon-class",
                        attrs: {
                          "popper-append-to-body": "false",
                          placement: "bottom-end",
                          trigger: "click",
                          "popper-class":
                            "popup-background profile-popup tootip-custom-small-width-class",
                        },
                        on: {
                          show: function ($event) {
                            _vm.passwordInfoActive = true
                          },
                          hide: function ($event) {
                            _vm.passwordInfoActive = false
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "content" }, [
                          _c("ul", { staticClass: "word-break" }, [
                            _c("li", [
                              _c("span", [
                                _vm._v(
                                  "Please fill the mandatory details (if any) for all steps and they will be available with “"
                                ),
                              ]),
                              _c("span", { staticClass: "mandatory-sign" }, [
                                _vm._v("*"),
                              ]),
                              _c("span", [_vm._v("” symbol.")]),
                            ]),
                            _c("li", [
                              _vm._v("Have at least one capital letter"),
                            ]),
                            _c("li", [_vm._v("Have at least one number")]),
                            _c("li", [
                              _vm._v(
                                "Have at least one special character !@#$.,+=( )_%^&*"
                              ),
                            ]),
                            _c("li", [_vm._v("Be at least 10 characters")]),
                          ]),
                        ]),
                        !_vm.passwordInfoActive
                          ? _c("img", {
                              staticClass: "info-img",
                              attrs: {
                                slot: "reference",
                                src: "/static/images/icons/info_icon.svg",
                                alt: "info-icon",
                              },
                              slot: "reference",
                            })
                          : _vm._e(),
                        _vm.passwordInfoActive
                          ? _c("img", {
                              staticClass: "info-img",
                              attrs: {
                                slot: "reference",
                                src: "/static/images/icons/info_icon_active.svg",
                                alt: "infoactive-icon",
                              },
                              slot: "reference",
                            })
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-12 col-sm-12 pt-10" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12 form-group" },
                      [_vm._v("Current Password")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-6 col-md-6 col-lg-12 password-flex",
                        class: !_vm.currentPasswordFlag ? "pb-8" : "pb-22",
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password.current_password,
                              expression: "password.current_password",
                            },
                          ],
                          ref: "inputCurrentTag",
                          staticClass: "form-control eye",
                          class: !_vm.currentPasswordFlag
                            ? "invalid-border"
                            : "",
                          attrs: {
                            type: "password",
                            placeholder: "Current password",
                          },
                          domProps: { value: _vm.password.current_password },
                          on: {
                            blur: _vm.validateCurrentPassword,
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.password,
                                "current_password",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm.showCurrentPassword
                          ? _c("img", {
                              staticClass: "eye-icon",
                              attrs: {
                                src: "/static/images/icons/eye.svg",
                                alt: "eye-icon",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.togglePassword(
                                    _vm.$refs.inputCurrentTag,
                                    "showCurrentPassword"
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                        !_vm.showCurrentPassword
                          ? _c("img", {
                              staticClass: "eye-slash-icon",
                              attrs: {
                                src: "/static/images/icons/eye_slash.svg",
                                alt: "eye-icon",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.togglePassword(
                                    _vm.$refs.inputCurrentTag,
                                    "showCurrentPassword"
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                    !_vm.currentPasswordFlag
                      ? _c(
                          "div",
                          { staticClass: "col-xs-8 custom-error-class" },
                          [_vm._v(" Current password is incorrect ")]
                        )
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "col-xs-12 col-sm-12 pt-10" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12 form-group" },
                      [_vm._v("New Password")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-6 col-md-6 col-lg-12 password-flex pb-20",
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.password.new_password,
                              expression: "password.new_password",
                              modifiers: { trim: true },
                            },
                          ],
                          ref: "inputNewTag",
                          staticClass: "form-control eye",
                          attrs: {
                            type: "password",
                            placeholder: "New password",
                          },
                          domProps: { value: _vm.password.new_password },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.password,
                                  "new_password",
                                  $event.target.value.trim()
                                )
                              },
                              _vm.validate,
                            ],
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm.showNewPassword
                          ? _c("img", {
                              staticClass: "eye-icon",
                              attrs: {
                                src: "/static/images/icons/eye.svg",
                                alt: "eye-icon",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.togglePassword(
                                    _vm.$refs.inputNewTag,
                                    "showNewPassword"
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                        !_vm.showNewPassword
                          ? _c("img", {
                              staticClass: "eye-slash-icon",
                              attrs: {
                                src: "/static/images/icons/eye_slash.svg",
                                alt: "eye-icon",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.togglePassword(
                                    _vm.$refs.inputNewTag,
                                    "showNewPassword"
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "col-xs-12 col-sm-12 mt-10" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12 form-group" },
                      [_vm._v("Confirm Password")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-6 col-md-6 col-lg-12 password-flex pb-5",
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.password.confirm_password,
                              expression: "password.confirm_password",
                              modifiers: { trim: true },
                            },
                          ],
                          ref: "inputConfirmTag",
                          staticClass: "form-control eye",
                          class:
                            _vm.password.confirm_password.length &&
                            _vm.password.new_password !=
                              _vm.password.confirm_password
                              ? "invalid-border"
                              : "",
                          attrs: {
                            type: "password",
                            placeholder: "Confirm password",
                          },
                          domProps: { value: _vm.password.confirm_password },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.password,
                                "confirm_password",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm.showConfirmPassword
                          ? _c("img", {
                              staticClass: "eye-icon",
                              attrs: {
                                src: "/static/images/icons/eye.svg",
                                alt: "eye-icon",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.togglePassword(
                                    _vm.$refs.inputConfirmTag,
                                    "showConfirmPassword"
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                        !_vm.showConfirmPassword
                          ? _c("img", {
                              staticClass: "eye-slash-icon",
                              attrs: {
                                src: "/static/images/icons/eye_slash.svg",
                                alt: "eye-icon",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.togglePassword(
                                    _vm.$refs.inputConfirmTag,
                                    "showConfirmPassword"
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                    _vm.password.confirm_password &&
                    _vm.password.new_password != _vm.password.confirm_password
                      ? _c(
                          "div",
                          { staticClass: "col-xs-8 custom-error-class" },
                          [_vm._v(" Password does not match. ")]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]
            ),
            _c("div", { staticClass: "footer col-xs-12 col-sm-12" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-md-2 col-md-offset-7 col-sm-offset-5 col-sm-3 col-xs-5 xs-pd-lt-0",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-white-button",
                      attrs: { type: "button" },
                      on: { click: _vm.unsetPasswordFlag },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col-md-3 col-sm-4 col-xs-7 xs-pd-lt-0 xs-pd-rt-0",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-green-button",
                      attrs: {
                        type: "button",
                        disabled:
                          !_vm.currentPasswordFlag ||
                          _vm.disableButtonForChangePassword ||
                          _vm.loaderStatus,
                      },
                      on: { click: _vm.updatePassword },
                    },
                    [_vm._v(" Save Changes ")]
                  ),
                ]
              ),
            ]),
          ]),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "confirmPopup", role: "dialog" },
        },
        [
          _c("div", { staticClass: "modal-dialog profile-confirm-poup" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(5),
              _c("div", { staticClass: "modal-body confirm-body" }, [
                _vm._v(
                  " Would you like to save your changes before leaving the page? "
                ),
              ]),
              _c("div", { staticClass: "modal-footer confirmpopup-bgcolor" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-md-6 col-sm-6 col-xs-12 profile-footer-save",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-green-button",
                        attrs: { type: "button" },
                        on: { click: _vm.confirmChanges },
                      },
                      [_vm._v(" Save Changes ")]
                    ),
                  ]
                ),
                _c("div", { staticClass: "col-md-6 col-sm-6 col-xs-12" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-white-button",
                      attrs: { type: "button" },
                      on: { click: _vm.cancelConfirmPopUp },
                    },
                    [_vm._v(" Discard Changes ")]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-12" }, [
      _c("hr"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-12 col-xs-12 form-group" }, [
      _vm._v(" First Name "),
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-12 col-xs-12 form-group" }, [
      _vm._v(" Last Name "),
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-12 col-xs-12" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-title" }, [
      _c("img", {
        staticClass: "expiry-img",
        attrs: {
          src: "/static/images/icons/expiring_yellow.svg",
          alt: "expiring-soon",
        },
      }),
      _c("span", [_vm._v("This Account will be Deactivated")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header confirmpopup-bgcolor" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-toggle": "modal",
            "data-target": "#confirmPopup",
          },
        },
        [_vm._v(" × ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }